<template>
    <div class="d-flex d-flex justify-content-center align-items-center flex-column mx-3" style="height: 100vh">
        <font-awesome-icon icon="check" size="8x" class="text-success"></font-awesome-icon>
        <h2 class="mt-2 text-center">
            {{ $t('bookings.bookingSuccessful') }}
        </h2>
        <base-button @click="showContractualInfo">
            {{ $t('bookings.openPrintView') }}
        </base-button>
        <span class="mt-2 text-center">{{ $t('bookings.yourBookingNumber') }}: {{ bookingData.id }}</span>
    </div>
</template>

<script>
import mainSiteMixin from "@/mixins/mainSiteMixin";
import contractualInfoMixin from "@/mixins/contractualInfoMixin";

export default {
    name: "SuccessFinishPage",
    mixins: [mainSiteMixin, contractualInfoMixin],
    methods: {
        async showContractualInfo() {
            const ref = this.openNewLoadingWindow();
            try {
                const response = await this.$axios.get(
                    this.$apiRoute('api.bookings.sites.bookings.getPrintView', {
                        site: this.siteData.id,
                        booking: this.bookingData.id
                    }),
                    {responseType: 'blob', params: {token: this.bookingData.token}}
                )
                ref.location.href = URL.createObjectURL(response.data);
            } catch (e) {
                console.log(e)
            }
            
            ref?.close()
        }
    }
}
</script>

<style scoped>

</style>
